import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { Invoice } from "@/types";

function InvoiceTypeBadge({ type }: { type: Invoice["type"] }) {
  return (
    <Badge
      variant={type === "revenue" ? "default" : "destructive"}
      className={cn(type === "revenue" && "bg-chart-2 dark:bg-chart-2")}
    >
      {type === "revenue" ? "Revenue" : "Expense"}
    </Badge>
  );
}

export default InvoiceTypeBadge;
